module.exports = Em.Mixin.create({
    _customActionsContacts: {
        createContact: function(e) {
            var isCustomer = true
            var isSupplier = false
            var typesHidden = false

            if (e && e.detail && e.detail.isCustomer !== undefined && e.detail.isSupplier !== undefined) {
                isCustomer = e.detail.isCustomer
                isSupplier = e.detail.isSupplier
                typesHidden = true
            }

            var contactEditor = this.container.lookup('component:contactEditor')
            var organization = this.get('organization')
            contactEditor.set('content', Billy.Contact.createRecord({
                organization: organization,
                country: organization.get('country'),
                type: 'company',
                isCustomer: isCustomer,
                isSupplier: isSupplier
            }))
            contactEditor.set('typesHidden', typesHidden)
            contactEditor.show()
        },

        editContact: function(e) {
            if (!e || !e.detail || !e.detail.contactId) {
                return
            }

            var contact = Billy.Contact.find(e.detail.contactId)
            if (!contact) {
                return
            }

            var contactEditor = this.container.lookup('component:contactEditor')
            contactEditor.set('content', contact)
            contactEditor.set('typesHidden', true)
            contactEditor.show()
        }
    }
})
